// FILE: /src/Components/PostUploader/ValidationTab.js (FULLY UPDATED)

import React, { useMemo, useEffect } from 'react';
import moment from 'moment';

const MAX_CAROUSEL_ITEMS = 10;

const hasReachedTikTokDailyLimit = (creatorInfo) => {
const remaining = creatorInfo?.remaining_daily_post_count;

if (remaining === null || remaining === undefined || remaining === '') {
return false;
}

return Number(remaining) === 0;
};

const ValidationTab = ({
    photoPreview = [],
    messages = '',
    selectedProfiles = [],
    pinterestOptions = {},
    linkedinOptions = {},
    youtubeOptions = {},
    tiktokOptions = {},
    tiktokCreatorInfo = null,
    tiktokCreatorInfoLoading = false,
    tiktokCreatorInfoError = null,
    scheduleType = 'now',
    scheduleDates = [],
    onValidationChange,
    fileErrors = [],
    }) => {
    const postLogicErrors = useMemo(() => {
        const newErrors = [];
        
        const hasMedia = photoPreview.length > 0;
        const hasText = messages.trim().length > 0;

        if (!hasMedia && !hasText) {
            newErrors.push("A post must have at least one media item or a caption.");
        }
        
        const isInstagramSelected = selectedProfiles.some(p => p.platform === 'INSTAGRAM');
        const isFacebookSelected = selectedProfiles.some(p => p.platform === 'FACEBOOK');
        const isLinkedInSelected = selectedProfiles.some(p => p.platform === 'LINKEDIN');
        const isYouTubeSelected = selectedProfiles.some(p => p.platform === 'YOUTUBE');
        const isTikTokSelected = selectedProfiles.some(p => p.platform === 'TIKTOK');

        const videoCount = photoPreview.filter(item => item.type === 'video').length;
        const imageCount = photoPreview.filter(item => item.type === 'image').length;
        const documentCount = photoPreview.filter(item => item.type === 'document').length;

        if (isTikTokSelected) {
const opts = tiktokOptions || {};
const commercialToggleOn = opts.brand_content_toggle === true;
const commercialTypeSelected =
opts.brand_organic_toggle === true ||
opts.branded_content_toggle === true ||
!!opts.branded_content_type;

const brandedContentOn =
opts.branded_content_toggle === true ||
opts.branded_content_type === "BRANDED_CONTENT";

const isTikTokPhotoPost = imageCount > 0 && videoCount === 0;
const selectedVideo = photoPreview.find(item => item.type === 'video');
const maxTikTokVideoDuration = Number(tiktokCreatorInfo?.max_video_post_duration_sec || 0);
const selectedVideoDuration = Number(selectedVideo?.metadata?.duration || 0);

if (tiktokCreatorInfoLoading) {
newErrors.push("TikTok creator settings are still loading. Please wait.");
}

if (tiktokCreatorInfoError) {
newErrors.push(tiktokCreatorInfoError);
}

if (!tiktokCreatorInfo && !tiktokCreatorInfoLoading && !tiktokCreatorInfoError) {
newErrors.push("TikTok creator settings must be loaded before posting.");
}

if (tiktokCreatorInfo?.can_post === false) {
newErrors.push("TikTok says this account cannot post right now. Please try again later or reconnect the account.");
}

if (hasReachedTikTokDailyLimit(tiktokCreatorInfo)) {
newErrors.push("This TikTok account has reached its daily posting limit. Please try again after TikTok resets the limit.");
}

if (!hasMedia) {
newErrors.push("TikTok posts require at least one image or a video.");
}

if (!opts.privacy_level) {
newErrors.push("TikTok privacy level is required. Please manually select who can view this post.");
}

if (
opts.privacy_level &&
Array.isArray(tiktokCreatorInfo?.privacy_level_options) &&
tiktokCreatorInfo.privacy_level_options.length > 0 &&
!tiktokCreatorInfo.privacy_level_options.includes(opts.privacy_level)
) {
newErrors.push("The selected TikTok privacy level is not available for this creator.");
}

if (commercialToggleOn && !commercialTypeSelected) {
newErrors.push("Select at least one TikTok commercial content disclosure option: Your brand or Branded content.");
}

if (brandedContentOn && opts.privacy_level === "SELF_ONLY") {
newErrors.push("Branded content visibility cannot be set to private.");
}

if (videoCount > 1) {
newErrors.push("TikTok only supports a single video per post.");
}

if (videoCount > 0 && imageCount > 0) {
newErrors.push("TikTok does not support mixed video and image posts.");
}

if (documentCount > 0) {
newErrors.push("Documents are not supported for TikTok.");
}

if (videoCount === 0 && imageCount > 35) {
newErrors.push(`TikTok photo slideshows are limited to 35 images. You have selected ${imageCount}.`);
}

if (isTikTokPhotoPost && (opts.duet_disabled === false || opts.stitch_disabled === false)) {
newErrors.push("TikTok Duet and Stitch are not available for photo posts.");
}

if (selectedVideo && maxTikTokVideoDuration > 0 && selectedVideoDuration > maxTikTokVideoDuration) {
newErrors.push(`TikTok video exceeds this creator's maximum allowed duration of ${maxTikTokVideoDuration} seconds.`);
}
}

        // --- START OF FIX: Updated Pinterest validation logic ---
        const pinterestProfiles = selectedProfiles.filter(p => p.platform === 'PINTEREST');
        if (pinterestProfiles.length > 0) {
            if (!hasMedia) newErrors.push("Pinterest posts require at least one image or video.");
            if (photoPreview.length > 1) newErrors.push("Pinterest only supports a single image or video per post.");

            pinterestProfiles.forEach(profile => {
                const options = pinterestOptions[profile.platform_id] || {}; // Safety check
                
                if (!options.board) {
                    newErrors.push(`A board must be selected for the '${profile.profile}' Pinterest account.`);
                }
                
                // The actual fix: Check if title exists before trimming
                if (!options.title || !options.title.trim()) {
                    newErrors.push(`A title is required for the '${profile.profile}' Pinterest Pin.`);
                }

                if (videoCount > 0 && !options.thumbnailUrl) {
                    newErrors.push(`A custom thumbnail is required for the '${profile.profile}' video Pin.`);
                }
            });
        }
        // --- END OF FIX ---
        
        if (isInstagramSelected && !hasMedia) {
            newErrors.push("Instagram posts require at least one image or video.");
        }
        if (isFacebookSelected && !hasMedia && !hasText) {
             newErrors.push("Facebook posts require media or a caption.");
        }
        
        if (isLinkedInSelected) {
            if (hasMedia && linkedinOptions.articleUrl) {
                newErrors.push("LinkedIn posts cannot have both an article link and uploaded media. Please choose one.");
            }
            if (documentCount > 0) {
                if (!linkedinOptions.documentTitle || !linkedinOptions.documentTitle.trim()) {
                    newErrors.push("A Document Title is required for LinkedIn document posts.");
                }
            }
            if (imageCount > 9) {
                newErrors.push(`LinkedIn carousels are limited to 9 images. You have selected ${imageCount}.`);
            }
            if (imageCount > 1 && videoCount > 0) {
                 newErrors.push("LinkedIn carousels only support images. Mixed media types are not allowed.");
            }
        }

        if (isYouTubeSelected) {
            if (videoCount === 0) {
                newErrors.push("YouTube posts require a video to be uploaded.");
            }
            if (photoPreview.length > 1) {
                newErrors.push("YouTube only supports single video uploads per post.");
            }
            selectedProfiles.forEach(profile => {
                if (profile.platform === 'YOUTUBE') {
                    const channelOptions = youtubeOptions[profile.platform_id];
                    if (!channelOptions || !channelOptions.title || !channelOptions.title.trim()) {
                        newErrors.push(`A title is required for the '${profile.profile}' YouTube channel.`);
                    }
                }
            });
        }
        
        // General Post Validations
        if (photoPreview.some(item => item.status === 'uploading')) {
            newErrors.push("Please wait for all media to finish uploading.");
        }
        
        if (documentCount > 0 && (imageCount > 0 || videoCount > 0)) {
            newErrors.push("Documents cannot be combined with images or videos in the same post.");
        }
        
        if (isFacebookSelected) {
            if (videoCount > 1) newErrors.push("Facebook doesn't support posts with multiple videos.");
            if (videoCount > 0 && imageCount > 0) newErrors.push("Facebook doesn't support mixed image/video posts.");
        }

        if (isInstagramSelected) {
            if (photoPreview.length > MAX_CAROUSEL_ITEMS) newErrors.push(`Instagram posts are limited to ${MAX_CAROUSEL_ITEMS} media items.`);
        }

        if (scheduleType === 'schedule') {
            if (!scheduleDates.every(d => d.date && d.time && d.date.isValid() && d.time.isValid())) {
                newErrors.push("All scheduled times must have a valid date and time.");
            } else if (!scheduleDates.every(d => moment(d.date).set({ hour: d.time.hour(), minute: d.time.minute() }).isAfter(moment()))) {
                newErrors.push("Scheduled time must be in the future.");
            }
        }
        
        return newErrors;
    }, [
        photoPreview,
        messages,
        selectedProfiles,
        pinterestOptions,
        linkedinOptions,
        youtubeOptions,
        tiktokOptions,
        tiktokCreatorInfo,
        tiktokCreatorInfoLoading,
        tiktokCreatorInfoError,
        scheduleType,
        scheduleDates
        ]);

    const allErrors = useMemo(() => [...postLogicErrors, ...fileErrors], [postLogicErrors, fileErrors]);

    useEffect(() => {
        onValidationChange(allErrors);
    }, [allErrors, onValidationChange]);

    const hasErrors = allErrors.length > 0;

    return (
        <div className={`p-4 border rounded-lg ${hasErrors ? 'bg-red-50 border-red-200' : 'bg-green-50 border-green-200'}`}>
            <h3 className={`font-semibold flex items-center gap-2 ${hasErrors ? 'text-red-700' : 'text-green-700'}`}>
                {hasErrors ? (
                    <i className="fa-solid fa-circle-exclamation"></i>
                ) : (
                    <i className="fa-solid fa-circle-check"></i>
                )}
                {hasErrors ? `Please resolve ${allErrors.length} issue(s)` : 'All checks passed!'}
            </h3>
            
            {hasErrors && (
                <ul className="mt-2 pl-5 space-y-1 text-sm text-red-600 list-disc">
                    {allErrors.map((error, index) => (
                        <li key={index}>{error}</li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default ValidationTab;